import { apiClient } from "@/lib/apiClient";

export interface PublicConfig {
  /** Stripe publishable key (pk_) — served by the API, not inlined into the bundle. */
  stripePublishableKey: string | null;
  /** Google Maps JS key for the recipient address autocomplete (host-restricted). */
  googleMapsApiKey: string | null;
  /** Smarty website key (`key=`) for client-side US address verification (host-restricted). */
  smartyApiKey: string | null;
}

export async function fetchPublicConfig(): Promise<PublicConfig> {
  const { data } = await apiClient.get<PublicConfig>("/config");
  return data;
}
